// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"136":"bf7c0fae","309":"dbc3bc29","425":"f9308fe7","453":"ba3fe99f","468":"605e845c","734":"a539fe48","755":"2c306177","759":"fa29c88a","868":"2c2fa498","875":"a93d3746","927":"c49ac384"}[chunkId] + ".chunk.js";
};